import { CircuitLocalized } from "../objects/circuitLocalized";

export const EMPTY_CIRCUIT_LOCALIZED: CircuitLocalized = {
    name: null,
    additional_information: null,
    board_type: null,
    condition: null,
    description: null,
    excluded_in_price: null,
    included_in_price: null,
    sale_pitch: '',
    strengths: null,
    locale: 0
};

export const DEFAULT_COLUMN = [{
    label: 'type',
    field_name: 'TYPE',
    checked: true,
    order_by: 'type',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'package-structure-type',
    field_name: 'PACKAGE_STRUCTURE_TYPE',
    checked: true,
    order_by: 'package_type',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'protected-description',
    field_name: 'PROTECTED_DESCRIPTION',
    checked: true,
    order_by: 'is_protected_description',
    fixed_width: false,
    last_updated: false
}, {
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'languages',
    field_name: 'LANGUAGES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'providers',
    field_name: 'PROVIDERS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'source',
    field_name: 'SOURCE',
    checked: true,
    order_by: 'source',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'reference',
    field_name: 'REFERENCE',
    checked: true,
    order_by: 'reference',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'destination',
    field_name: 'DESTINATION',
    checked: true,
    order_by: 'destination__current_version__localization__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'country',
    field_name: 'COUNTRY',
    checked: true,
    order_by: 'destination__current_version__country__international_name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'categories',
    field_name: 'CATEGORIES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'online-to',
    field_name: 'VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'online-b2b',
    field_name: 'AGENCY_VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'allowed-cms',
    field_name: 'ALLOWED_CMS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const CMS_COLUMN = [{
    label: 'type',
    field_name: 'TYPE',
    checked: true,
    order_by: 'type',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'package-structure-type',
    field_name: 'PACKAGE_STRUCTURE_TYPE',
    checked: true,
    order_by: 'package_type',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'protected-description',
    field_name: 'PROTECTED_DESCRIPTION',
    checked: true,
    order_by: 'is_protected_description',
    fixed_width: false,
    last_updated: false
}, {
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'languages',
    field_name: 'LANGUAGES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'providers',
    field_name: 'PROVIDERS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'source',
    field_name: 'SOURCE',
    checked: true,
    order_by: 'source',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'reference',
    field_name: 'REFERENCE',
    checked: true,
    order_by: 'reference',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'destination',
    field_name: 'DESTINATION',
    checked: true,
    order_by: 'destination__current_version__localization__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'country',
    field_name: 'COUNTRY',
    checked: true,
    order_by: 'destination__current_version__country__international_name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'categories',
    field_name: 'CATEGORIES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'online-to',
    field_name: 'VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'online-b2b',
    field_name: 'AGENCY_VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'island-number',
    field_name: 'ISLAND_NUMBER',
    checked: true,
    order_by: 'nb_of_islands_included',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'allowed-cms',
    field_name: 'ALLOWED_CMS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];


export const ONLINE_CIRCUIT_COLUMN = [{
    label: 'type',
    field_name: 'TYPE',
    checked: true,
    order_by: 'type',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'supplier-name',
    field_name: 'SUPPLIER_NAME',
    checked: true,
    order_by: 'to_name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'languages',
    field_name: 'LANGUAGES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'providers',
    field_name: 'PROVIDERS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'source',
    field_name: 'SOURCE',
    checked: true,
    order_by: 'source',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'reference',
    field_name: 'REFERENCE',
    checked: true,
    order_by: 'reference',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'destination',
    field_name: 'DESTINATION',
    checked: true,
    order_by: 'destination__current_version__localization__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'country',
    field_name: 'COUNTRY',
    checked: true,
    order_by: 'destination__current_version__country__international_name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'categories',
    field_name: 'CATEGORIES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'online-to',
    field_name: 'VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'online-b2b',
    field_name: 'AGENCY_VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false
}, {
    label: 'allowed-cms',
    field_name: 'ALLOWED_CMS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const ONLINE_CIRCUIT_CMS_COLUMN = [{
    label: 'type',
    field_name: 'TYPE',
    checked: true,
    order_by: 'type',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'supplier-name',
    field_name: 'SUPPLIER_NAME',
    checked: true,
    order_by: 'to_name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'languages',
    field_name: 'LANGUAGES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'providers',
    field_name: 'PROVIDERS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'source',
    field_name: 'SOURCE',
    checked: true,
    order_by: 'source',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'reference',
    field_name: 'REFERENCE',
    checked: true,
    order_by: 'reference',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'destination',
    field_name: 'DESTINATION',
    checked: true,
    order_by: 'destination__current_version__localization__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'country',
    field_name: 'COUNTRY',
    checked: true,
    order_by: 'destination__current_version__country__international_name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'categories',
    field_name: 'CATEGORIES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'online-to',
    field_name: 'VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'online-b2b',
    field_name: 'AGENCY_VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'island-number',
    field_name: 'ISLAND_NUMBER',
    checked: true,
    order_by: 'nb_of_islands_included',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'allowed-cms',
    field_name: 'ALLOWED_CMS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];
